<template>
  <div :class="$style.box">
    <div
      :class="$style.content"
      :style="contentStyle"
    >
      <iframe
        v-if="currentActivitySrc"
        ref="activityFrame"
        :key="currentActivitySrc"
        :src="currentActivitySrc"
        :class="$style.iframe"
        frameborder="0"
        scrolling="yes"
        @error="handleIframeError"
      ></iframe>
      <p v-else :class="$style.error">{{ errorMsg || '暂无活动内容' }}</p>
    </div>

    <!-- <div
      v-if="bridgeBottomNavVisible"
      ref="activityBottomNav"
      :class="$style.bottomNav"
      :style="{ height: `calc(${bottomNavHeight}px + env(safe-area-inset-bottom))` }"
    >
      <div
        v-for="(item, index) in activityList"
        :key="`activity-bottom-nav-${index}-${item.name}`"
        :ref="`activityBottomNavItem${index}`"
        :class="$style.navItem"
        @click="changeActivity(item)"
      >
        <span :class="[$style.name, isActiveNavigation(item) && $style.active]">
          {{ item.name }}
        </span>
        <div
          v-if="shouldShowPopText(item)"
          :ref="`activityBottomPop${index}`"
          :class="$style.popText"
          :style="getPopTextStyle(index)"
        >
          {{ getPopText(item.pop_text) }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getNavigationData } from '@/api/giftCenter';
import { appendUrlQueryParams, localLinkJump } from '@/utils/index.js';
import bottomNavigationMixin from '@/mixins/bottomNavigationMixin.js';

export default {
  mixins: [bottomNavigationMixin],
  data() {
    return {
      activityName: '',
      activityList: [],
      currentActivityUrl: '',
      errorMsg: '',
      popTextStyleMap: {},
      bottomNavHeight: 52,
      jumpType: 'activity',
      navigationLevel: '',
      navigationRequestId: 0,
      viewportHeight: 0,
    };
  },
  mounted() {
    this.updateViewportHeight();
    this.initActivityData();
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  watch: {
    '$route.query': {
      handler() {
        this.initActivityData();
      },
      deep: true,
    },
  },
  methods: {
    handleWindowResize() {
      this.updateViewportHeight();
      this.updatePopTextPosition();
    },
    updateViewportHeight() {
      this.viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    },
    async initActivityData() {
      const requestId = ++this.navigationRequestId;
      const { name, url, jumpType, level, list } = this.$route.query;
      this.jumpType = this.getValidJumpType(jumpType);
      this.navigationLevel = level || '';
      this.activityName = name || '';
      this.currentActivityUrl = String(url || '').trim();

      let activityList = [];
      try {
        const r = await getNavigationData({ type: this.navigationType });
        activityList = this.normalizeNavigationList(r.data);
      } catch (error) {
        activityList = [];
      }

      if (requestId !== this.navigationRequestId) return;

      if (!activityList.length) {
        activityList = this.parseQueryActivityList(list);
      }

      if (this.jumpType === 'bottom') {
        activityList = this.getCurrentLevelBottomNavigation(activityList);
      }

      if (!activityList.length && this.currentActivityUrl) {
        activityList = [
          {
            name: this.activityName || '活动',
            url: this.currentActivityUrl,
            pop_text: '',
            url_type: 2,
          },
        ];
      }

      this.activityList = activityList;

      if (!this.currentActivityUrl && this.activityList.length) {
        this.currentActivityUrl = this.activityList[0].url;
      }

      const activeItem = this.activityList.find((item) => this.isActiveNavigation(item));
      this.activityName = activeItem ? activeItem.name : this.activityName;
      this.errorMsg = this.currentActivityUrl ? '' : '活动地址为空，请返回礼包中心重试';
      this.$nextTick(() => {
        this.updatePopTextPosition();
      });
    },
    getValidJumpType(jumpType) {
      return jumpType === 'bottom' ? 'bottom' : 'activity';
    },
    normalizeNavigationList(list) {
      if (!Array.isArray(list)) return [];
      return list.map((item) => ({
        ...item,
        name: item.name || '活动',
        url: String(item.url || '').trim(),
        pop_text: item.pop_text || item.remark || item.popText || '',
      }));
    },
    parseQueryActivityList(list) {
      try {
        const listStr = decodeURIComponent(String(list || ''));
        return this.normalizeNavigationList(JSON.parse(listStr));
      } catch (error) {
        return [];
      }
    },
    getCurrentLevelBottomNavigation(navList) {
      if (!Array.isArray(navList)) return [];
      let level = String(this.navigationLevel || '');
      if (!level && this.currentActivityUrl) {
        const activeItem = navList.find((item) => String(item.url || '').trim() === this.currentActivityUrl);
        level = activeItem && activeItem.level ? String(activeItem.level) : '';
      }
      const currentLevelList = level
        ? navList.filter((item) => String(item.level || '') === level)
        : navList;
      return currentLevelList.slice().reverse();
    },
    hasPopText(text) {
      return !!String(text || '').trim();
    },
    isActivityNavigation(item) {
      return Number(this.navigationType) === 3 || Number(item && item.type) === 3;
    },
    shouldShowPopText(item) {
      return !this.isActivityNavigation(item) && this.hasPopText(item && item.pop_text);
    },
    getPopText(text) {
      if (!text) return '';
      const textStr = String(text)
        .replace(/\r?\n/g, '')
        .trim();
      if (!textStr) return '';
      const charList = Array.from(textStr);
      if (charList.length <= 10) return textStr;
      return `${charList.slice(0, 9).join('')}...`;
    },
    getRefEl(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    getPopTextStyle(index) {
      return this.popTextStyleMap[index] || {
        left: '50%',
        maxWidth: 'calc(100vw - 12px)',
        transform: 'translateX(-50%)',
      };
    },
    updatePopTextPosition() {
      const styleMap = {};
      const navList = this.activityList;
      const boxEl = this.$refs.activityBottomNav;

      if (!boxEl) return;

      navList.forEach((item, index) => {
        const listEl = this.getRefEl(`activityBottomNavItem${index}`);
        const popEl = this.getRefEl(`activityBottomPop${index}`);

        if (!listEl || !popEl) {
          return;
        }

        let nextPopListEl = null;
        for (let nextIndex = index + 1; nextIndex < navList.length; nextIndex += 1) {
          if (this.shouldShowPopText(navList[nextIndex])) {
            nextPopListEl = this.getRefEl(`activityBottomNavItem${nextIndex}`);
            break;
          }
        }

        const boxWidth = boxEl.scrollWidth || boxEl.offsetWidth || window.innerWidth;
        const maxRight = nextPopListEl ? nextPopListEl.offsetLeft : boxWidth;
        const availableWidth = Math.max(listEl.offsetWidth, maxRight - listEl.offsetLeft);
        const popWidth = Math.min(popEl.scrollWidth || popEl.offsetWidth, availableWidth);
        const centeredLeft = listEl.offsetWidth / 2 - popWidth / 2;
        const maxLeft = Math.max(0, availableWidth - popWidth);
        const popLeft = Math.min(Math.max(centeredLeft, 0), maxLeft);

        styleMap[index] = {
          left: `${popLeft}px`,
          maxWidth: `${availableWidth}px`,
          transform: 'none',
        };
      });

      this.popTextStyleMap = styleMap;
      this.$nextTick(() => {
        this.updateBottomNavHeight();
      });
    },
    updateBottomNavHeight() {
      let maxPopHeight = 0;
      this.activityList.forEach((item, index) => {
        const popEl = this.getRefEl(`activityBottomPop${index}`);
        if (popEl) {
          maxPopHeight = Math.max(maxPopHeight, popEl.offsetHeight);
        }
      });

      const baseHeight = 52;
      const popBottom = 34;
      const topPadding = 6;
      this.bottomNavHeight = Math.max(baseHeight, maxPopHeight + popBottom + topPadding);
    },
    changeActivity(item) {
      if (!item || !item.url) return;
      if (!this.isExternalNavigation(item)) {
        localLinkJump(item.url);
        return;
      }
      this.currentActivityUrl = String(item.url).trim();
      this.activityName = item.name || '活动中心';
      this.errorMsg = this.currentActivityUrl ? '' : '活动地址为空，请返回礼包中心重试';
      this.$nextTick(() => {
        this.updatePopTextPosition();
      });
    },
    handleIframeError() {
      if (!this.currentActivitySrc) return;
      // 目标页面拒绝被 iframe 嵌入时，退化为整页打开，避免空白。
      window.location.href = this.currentActivitySrc;
    },
    isActiveNavigation(item) {
      return String(item && item.url ? item.url : '').trim() === this.currentActivityUrl;
    },
    isLocalHashRoute(url) {
      const targetUrl = String(url || '').trim();
      if (!targetUrl) return false;
      if (targetUrl.startsWith('#/')) return true;

      try {
        const parsedUrl = new URL(targetUrl, window.location.origin);
        return parsedUrl.origin === window.location.origin && parsedUrl.hash.startsWith('#/');
      } catch (error) {
        return false;
      }
    },
    isExternalNavigation(item) {
      if (this.isLocalHashRoute(item.url)) return false;
      if (item.url_type == 2) return true;
      return /^(https?:)?\/\//i.test(String(item.url || '').trim());
    },
    getActivityQueryParams() {
      const userInfo = this.userInfo || {};
      return {
        uid: userInfo.game_user_id || '',
        openid: userInfo.open_id || userInfo.openid || '',
        jumpType: this.jumpType,
      };
    },
    appendActivityQueryParams(rawUrl) {
      return appendUrlQueryParams(rawUrl, this.getActivityQueryParams());
    },
    getActivitySrc(rawUrl) {
      const targetUrl = this.appendActivityQueryParams(rawUrl);
      if (!targetUrl) return '';

      try {
        const parsedUrl = new URL(targetUrl, window.location.origin);
        if (
          parsedUrl.origin === window.location.origin &&
          parsedUrl.hash &&
          parsedUrl.hash.startsWith('#/')
        ) {
          return `${window.location.origin}${window.location.pathname}${parsedUrl.search}${parsedUrl.hash}`;
        }
        return parsedUrl.href;
      } catch (error) {
        return targetUrl;
      }
    },
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo || {},
    }),
    ...mapState('app', {
      bottomNavArray: (state) => state.bottomNavArray || [],
    }),
    navigationType() {
      return this.jumpType === 'bottom' ? 1 : 3;
    },
    bridgeBottomNavVisible() {
      return this.activityList.length > 0 && !this.hasMatchedBottomNav;
    },
    contentStyle() {
      const viewportHeight = this.viewportHeight || window.innerHeight || document.documentElement.clientHeight || 0;
      const shouldReserveBottomNav =
        this.hasMatchedBottomNav || (this.bridgeBottomNavVisible && this.navigationType !== 3);
      const contentHeight = shouldReserveBottomNav
        ? Math.max(0, viewportHeight - this.bottomNavHeight)
        : viewportHeight;
      return {
        height: contentHeight ? `${contentHeight}px` : `calc(100vh - ${this.bottomNavHeight}px)`,
      };
    },
    currentActivitySrc() {
      return this.getActivitySrc(this.currentActivityUrl);
      // return 'https://platform-common-h5-test.hzwxbz999.cn/page/10427?_s=0uWK1XgnH%2Ftj3vWmiyLuv7MpjFkSDlHhkTao3h1p1VE%3D&uid=708499&openid=olEMh57JnUUby3iaBH0oHnJZGhIs&jumpType=activity'
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.content {
  position: relative;
  width: 100%;
  height: calc(100vh - 52px - env(safe-area-inset-bottom));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}
.iframe {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 100%;
  border: none;
}
.error {
  padding-top: 32px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
.bottomNav {
  position: fixed;
  z-index: 98;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(52px + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  align-items: flex-end;
  background: #fff;
  box-shadow: -3px 0 10px rgba(159, 159, 159, 1);
  overflow-x: auto;
  overflow-y: visible;
}
.navItem {
  position: relative;
  flex: 1;
  min-width: 72px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name {
  display: inline-block;
  width: 100%;
  padding: 0 6px;
  line-height: 52px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: rgba(159, 159, 159, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.active {
  color: rgba(255, 130, 50, 1);
}
.popText {
  position: absolute;
  bottom: 34px;
  left: 50%;
  transform: none;
  width: max-content;
  max-width: calc(100vw - 12px);
  padding: 0 8px;
  border: 1px solid #FFC554;
  border-radius: 6px 6px 6px 0;
  background: #FFC554;
  font-size: 11px;
  font-weight: 400;
  color: #742600;
  line-height: 15px;
  white-space: normal;
  word-break: break-all;
  text-align: center;
  box-sizing: border-box;
  z-index: 3;
  pointer-events: none;
}
</style>
